<!-- =========================================================================================
    File Name: ChatNavbar.vue
    Description: Chat Application - Chat navbar
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div v-if="activeUser && activeUser.id" class="chat__header">
    <vs-navbar class="p-4 flex navbar-custom" color="white" type="flat">
      <div class="relative flex mr-4">
        <feather-icon
          icon="MenuIcon"
          class="mr-4 cursor-pointer"
          v-if="isSidebarCollapsed"
          @click.stop="$emit('openContactsSidebar')"
        ></feather-icon>
        <vs-avatar
          class="m-0"
          size="40px"
          :src="require(`@/assets/images/group-icon.png`)"
        />
        <!-- <div class="h-3 w-3 border-white border border-solid rounded-full absolute pin-r pin-b" :class="'bg-' + getStatusColor(false)"></div> -->
      </div>
      <h6>{{ activeUser.name }}</h6>
      <vs-spacer></vs-spacer>
      <vs-button
        v-show="activeUser.mentorSessionId"
        v-if="$acl.not.check('Mentor')"
        id="end-chat-button"
        color="danger"
        icon-pack="feather"
        icon="icon-x-circle"
        @click="endChat"
        >End Chat</vs-button
      >
    </vs-navbar>
  </div>
</template>

<script>
export default {
  props: {
    activeUser: {
      type: Object,
      required: true,
    },
    isPinnedProp: {
      type: Boolean,
      required: true,
    },
    isSidebarCollapsed: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      // contacts: contacts,
      isPinnedLocal: this.isPinnedProp,
    };
  },
  watch: {
    isPinnedProp(val) {
      this.isPinnedLocal = val;
    },
  },
  computed: {
    getStatusColor() {
      return (isActiveUser) => {
        const userStatus = this.getUserStatus(isActiveUser);

        if (userStatus == "online") {
          return "success";
        } else if (userStatus == "do not disturb") {
          return "danger";
        } else if (userStatus == "away") {
          return "warning";
        } else {
          return "grey";
        }
      };
    },
  },
  methods: {
    endChat() {
      this.$emit("showEndChatPopup");
    }
  },
};
</script>
<style lang="scss">
#pin-icon {
  > svg {
    color: #212744 !important;
  }
}

#end-chat-button {
  border-radius: 25px !important;

  .vs-button--text {
    text-transform: uppercase !important;
  }

  .vs-icon {
    font-size: 1.2rem !important;
  }
}
</style>